/**
 * KPI 성과 점수 lookup table 타입 정의
 * 복잡한 성과 점수 변환을 수식으로 표현하기 어려운 경우 사용
 */
export interface KpiScore {
  /** 성과 지수명 (예: A, B, C, 우수, 양호 등) */
  name: string

  /** 성과 점수 변환 기준 최소값 */
  minValue: number

  /** 성과 점수 변환 기준 최대값 */
  maxValue: number

  /** 성과 지수 점수 (선택사항) */
  score?: number

  /** 성과 지수 색상 (선택사항) */
  color?: string

  /** 성과 지수 설명 (선택사항) */
  description?: string
}

/**
 * KPI 성과 점수 lookup table 배열 타입
 */
export type KpiScores = KpiScore[]
